import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { APIService } from 'api/module'
import { TapeGroup } from 'elements-sdk'

@Component({
  templateUrl: './backupAddDirModal.component.pug',
})
export class BackupAddDirModalComponent {
  @Input() paths: string[]
  @Input() tapegroups: TapeGroup[]
  tapegroup: TapeGroup

  constructor (
    private modalInstance: NgbActiveModal,
    private api: APIService,
  ) { }

  async ngOnInit () {
    this.tapegroups ??= await this.api.tapeArchive.getAllTapeGroups({})
    this.tapegroup = this.tapegroups[0]
  }

  add (include, options?) {
    this.modalInstance.close(this.paths.map(p => ({
      path: p,
      include,
      options,
    })))
  }

  cancel () {
    this.modalInstance.dismiss()
  }
}
